import { TActionButton } from './actionButton';
import { TMessageBubble } from './messageBubble';
import { TMessageFiles } from './messageFiles';
import { IOfferForClientSchema } from '../repositories/chats/entities/for_client/OfferForClientSchema';
import {
  IMessageListItemV1Schema,
  EType,
} from '../repositories/chats/entities/message_list_item_v1/MessageListItemV1Schema';
import { IMessagesOfferResponse } from '../repositories/chats/v1/messages/offer';
import { IMessagesResponseError } from '../repositories/chats/v2/messages';

import type { IMessageAssumptionsSchema } from '../repositories/chats/entities/check_message/MessageAssumptionsSchema';

type TMessageSchema = Omit<IMessageListItemV1Schema, 'chatId' | 'userId'> & {
  chatId: string;
  userId: number;
};

enum EOutcomingStatus {
  Pending = 'pending',
  Failed = 'failed',
  Fulfilled = 'fulfilled',
  Read = 'read',
}

type TOutcomingStatus = `${EOutcomingStatus}`;

type TBaseMessage = {
  created: number;
  message: string;
  htmlText?: string | null;
  byMasterAgent?: boolean | null;
  userId: number;
  actionButtons?: TActionButton[];
  promoName?: string;
  files?: TMessageFiles;
  isRead?: boolean;
  assumptions?: IMessageAssumptionsSchema;
  offers?: IOfferForClientSchema[];
  bubbles?: TMessageBubble[];
  type?: EType;
  isOutcoming: boolean;
};

type TIncomingMessage = TBaseMessage & {
  isRead: boolean;
};

type TOutcomingMessage = TBaseMessage & {
  status: TOutcomingStatus;
};

type TMessage = TIncomingMessage | TOutcomingMessage;

type TMessagesOfferResponse = IMessagesOfferResponse & {
  data: any;
};

export {
  EType as EMessageType,
  IMessageAssumptionsSchema,
  IMessagesResponseError as TMessagesResponseError,
  TMessage,
  TMessageSchema,
  TMessagesOfferResponse,
  TOutcomingStatus,
  EOutcomingStatus,
};
